import { bootInstance } from "./instance.js";

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".gpxtr").forEach(bootInstance);
});
